import { render, staticRenderFns } from "./modal-listaprodutos-pedido.vue?vue&type=template&id=8ceadddc"
import script from "./modal-listaprodutos-pedido.vue?vue&type=script&lang=js"
export * from "./modal-listaprodutos-pedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports